import { createPersistedOptimisticOverlay } from '@/util/persistedOptimisticOverlay'
import type { TrackLikesContext } from '@amzn/bf-playback'
import { LIKE_STATES, type LikeState } from '@/track/trackLikeState'

// Leaf (see persistedOptimisticOverlay) so the boot-eager reapply doesn't drag
// trackLikeService's mutation + toggle machinery onto the entry chunk.
export const trackLikeOverlay = createPersistedOptimisticOverlay<LikeState>({
    persistenceKey: 'overlay:trackLike',
    validateValue: (v): v is LikeState => LIKE_STATES.includes(v as LikeState),
    buildEntity: (trackId, likeState): TrackLikesContext => ({
        __typename: 'Track',
        id: trackId,
        likesContext: { liked: likeState === 'LIKE', state: likeState },
    }),
})

/** Re-arm the normalized cache from persisted track likes on boot. */
export const reapplyPersistedTrackLikes = trackLikeOverlay.reapplyPersisted
